module.exports = __webpack_public_path__ + "img/block-angry.8f6237b8.jpg";